import en from './locale/en';
import es from './locale/es';

export default {
  en,
  es,
};
